import type { Provider } from '@angular/core';

import { DownloadAggregatedInsightsSummaryService } from '#modules/statistics/services/csv-insights-summary/download-aggregaed-insights-summary.service';
import { DownloadInsightsCsvSummaryBaseService } from '#modules/statistics/services/csv-insights-summary/download-insights-summary-base.service';
import { AggregatedCsvInsightsSummaryV2Service } from '#modules/statistics/services/csv-summary/aggregated-insights/aggregated-summary-v2/aggregated-summary-v2.service';
import { CsvInsightsSummaryService } from '#modules/statistics/services/csv-summary/insights/summary.service';

export const DOWNLOAD_AGGREGATED_INSIGHTS_SUMMARY_PROVIDERS: Provider[] = [
    // Generic Service
    DownloadInsightsCsvSummaryBaseService,
    // Specific Services
    DownloadAggregatedInsightsSummaryService,
    AggregatedCsvInsightsSummaryV2Service,
    // Dependency Services
    CsvInsightsSummaryService,
];
